// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-question-mark-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.031 12.719A4.784 4.784 0 0 1 7.69 8.322M5.813 6.875a2.922 2.922 0 1 0 0-5.844 2.922 2.922 0 0 0 0 5.844zm6.969 4.725a.331.331 0 0 1 .259.258.323.323 0 0 1 .004.095l-.023.095a.328.328 0 0 1-.303.202.995.995 0 0 0-.423.094.991.991 0 0 0 .09-.32l.005-.102a.33.33 0 0 1 .202-.303l.094-.023a.323.323 0 0 1 .095.004z' />
    <path
      fill='currentColor'
      d='M12.719 8.469a4.25 4.25 0 1 1 0 8.5 4.25 4.25 0 0 1 0-8.5zm-.696 5.586a1.26 1.26 0 0 0-.57 1.054 1.266 1.266 0 0 0 2.524.13l.007-.13c0-.38-.17-.72-.437-.952l-.3-.016a48.545 48.545 0 0 1-1.225-.086zm1.15-4.416a2.33 2.33 0 0 0-2.39.99 2.329 2.329 0 0 0-.392 1.293l.004.102a1 1 0 0 0 1.418.803.995.995 0 0 0-.09.32l-.004.103c0 .275.111.522.29.703.524.046 1.221.086 1.625.107.131-.055.258-.122.378-.202a2.332 2.332 0 0 0 .99-2.39 2.33 2.33 0 0 0-1.83-1.83z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
